import {useDispatch} from "react-redux";
import {notify} from "../../utils";
import {setCertType} from "../../redux/actions/FirstInfoAction";
import {useNavigate} from "react-router-dom";


export default function SelectCertType({errorMessage}) {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const certTypeHandle = (value) => {

        if(errorMessage) {
            notify(errorMessage)
        }else {
            const certTypeData = {
                certType: value,
            }

            dispatch(setCertType(certTypeData))
            navigate('/login')
        }

    }

    return(
        <>
            
            {/* <div className={`my-5 pb-4`} style={{minHeight: "54vh"}}> */}
                {/* <div className={`mt-5 pt-3`}>
                    <p className="mb-1 p-0 mt-3 text-center show-info-title" style={{"fontSize": "1.1rem"}}>انتخاب نوع گواهی</p>
                    <p className="show-info-text text-center p-0">نوع گواهی الکترونیکی مورد نظر خود را انتخاب نمایید</p>
                </div> */}

                <div className={`row w-100 justify-content-center pt-3`}
                     style={{"color" : "#044448"}}
                >

                    <div className={`col-12 col-md-5 ms-md-3 p-0 pb-2 border-shadow text-center pointer`}
                         onClick={() => certTypeHandle('PERSONALITY')}
                    >
                        <div className={`green-box`}>
                            <div className={`green-semi-circle`}></div>
                            <img className={`select-type-image`} src={require('../../../image/Group999.png')} />
                        </div>

                        <div className={` pt-4 mt-5`}>
                            <p className={`mb-1`} style={{"fontSize" : "0.7rem"}}>گواهی امضای دیجیتال</p>
                            <p style={{"fontWeight" : "700", "fontSize" : "1.2rem"}}>شخص حقیقی</p>
                        </div>

                    </div>

                    <div className={`col-12 col-md-5 me-md-2 mt-4 mt-md-0 p-0 pb-2 border-shadow text-center pointer`}
                         onClick={() => certTypeHandle('COMPANY')}
                    >
                        <div className={`green-box`}>
                            <div className={`green-semi-circle`}></div>
                            <img className={`select-type-image`} src={require('../../../image/Group997.png')} />
                        </div>

                        <div className={` pt-4 mt-5`} >
                            <p className={`mb-1`} style={{"fontSize" : "0.7rem"}}>گواهی امضای دیجیتال</p>
                            <p style={{"fontWeight" : "700", "fontSize" : "1.2rem"}}> شخص حقوقی
                            <span  style={{"fontSize" : "0.8rem"}}>(مهر سازمانی)</span>
                            </p>
                        </div>

                    </div>
                </div>
            {/* </div> */}
        </>

    )
}